module.exports = __webpack_public_path__ + "img/q3-6.48e8e9cb.png";